import React from "react";
import { Card } from "./styles";

import ReportsRedeSusView from "../../views/ReportsRedeSus/index.jsx";

export default function HomeUnimed() {
  return (
    <div>
      <Card>
        <ReportsRedeSusView />
      </Card>
    </div>
  );
}
